<template>
  <v-dialog
    :value="value"
    width="500"
    @input="handleInput"
  >
    <v-form @submit.prevent.stop="submit">
      <v-card>
        <v-toolbar
          flat
          dark
          color="primary"
        >
          {{ title }}
          <v-spacer />
          <v-btn
            icon
            dark
            @click="$emit('input', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-text-field
            v-model="form.name"
            :label="$t('Enter a name for the password')"
            class="mb-2"
            persistent-hint
            :hint="$t('For example, Internal users, Customers, etc.')"
            outlined
            :autofocus="mode === 'create'"
            :error-messages="form.errors.name"
          />

          <v-text-field
            v-model="form.password"
            :label="$t('Password')"
            class="password-input"
            :error-messages="form.errors.password"
            outlined
          >
            <template #append>
              <v-btn
                size="small"
                color="primary"
                @click.stop="generatePassword"
              >
                Generate
              </v-btn>
            </template>
          </v-text-field>

          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <date-picker
                v-model="form.valid_from"
                :max="form.valid_to"
                :label="$t('Valid from')"
                :error-messages="form.errors.valid_from"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <date-picker
                v-model="form.valid_to"
                :min="form.valid_from"
                :label="$t('Valid to')"
                :error-messages="form.errors.valid_to"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="$emit('input', false)"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            type="submit"
            :loading="form.processing"
            :disabled="form.processing"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { generateRandomString } from '@/lib/utils';

export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create',
      validator: (value) => {
        return ['create', 'edit'].includes(value);
      }
    },
    password: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        name: '',
        password: '',
        valid_from: null,
        valid_to: null,
      }),
    }
  },

  computed: {
    title() {
      switch (this.mode) {
        case 'create':
          return this.$t('Create password');
        case 'edit':
          return this.$t('Edit password');
        default:
          return '';
      }
    }
  },

  watch: {
    value: function(value) {
      this.form.reset();

      if (this.mode === 'edit' && value) {
        this.form.name = this.password.name;
        this.form.password = this.password.password;
        this.form.valid_from = this.password.valid_from;
        this.form.valid_to = this.password.valid_to;
      }
    }
  },

  methods: {
    submit() {
      switch (this.mode) {
        case 'create':
          this.handleCreate();
          break;

        case 'edit':
          this.handleUpdate();
          break;
      }
    },

    generatePassword() {
      this.form.password = generateRandomString(16);
    },

    handleCreate() {
      const url = this.route('faq-settings.portal.password.store', this.faqId);

      this.form.post(url.toString(), {
        onSuccess: () => {
          this.$emit('input', false);
        }
      });
    },

    handleUpdate() {
      const url = this.route('faq-settings.portal.password.update', [this.faqId, this.password.id]);

      this.form.patch(url.toString(), {
        onSuccess: () => {
          this.$emit('input', false);
        }
      });
    },

    handleInput(value) {
      this.$emit('input', value);
    }
  }
}
</script>

<style scoped>
  :deep(.password-input .v-input__append-inner) {
    margin-top: 10px !important;
  }
</style>